package com.eladfinish.bible.contest.screens.search.history

import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.input.TextFieldValue
import com.eladfinish.bible.contest.screens.search.mvi.SearchState

/**
 * The state for re-running a history entry. Only the options that affect that kind of search are
 * restored; the rest keep their current values. The mikud itself is never part of an entry, so a
 * by-mikud entry runs on whatever the mikud is now.
 */
fun SearchState.restoredFrom(key: SearchHistoryKey): SearchState {
    val withQuery = copy(
        textFieldValue = TextFieldValue(
            text = key.query,
            selection = TextRange(key.query.length),
        ),
        errorMessage = null,
        dialogState = SearchState.DialogState.None,
    )

    return when (key.kind) {
        SearchHistoryKind.REGULAR ->
            withQuery.copy(
                onlyQri = key.onlyQri,
                withNikud = key.withNikud,
                withTeamim = key.withTeamim,
                searchMode = key.searchMode,
                searchPlace = key.searchPlace,
            )

        SearchHistoryKind.ROOT ->
            withQuery.copy(onlyQri = key.onlyQri)

        SearchHistoryKind.NUMBER, SearchHistoryKind.DATE ->
            withQuery
    }
}

fun SearchState.toSearchHistoryKey(): SearchHistoryKey =
    SearchHistoryKey(
        query = query,
        onlyQri = onlyQri,
        withNikud = withNikud,
        withTeamim = withTeamim,
        searchMode = searchMode,
        searchPlace = searchPlace,
    )
